import 'react';
import '../scss/br-category.scss';

export default () => null;
